module.exports = __webpack_public_path__ + "img/MBB0228.c4c62dfd.png";